var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 4.30005C2.172 4.30005 2 5.17405 2 12C2 18.826 2.172 19.7 12 19.7C21.828 19.7 22 18.826 22 12C22 5.17405 21.828 4.30005 12 4.30005ZM15.205 12.334L10.715 14.43C10.322 14.612 10 14.408 10 13.974V10.026C10 9.59305 10.322 9.38805 10.715 9.57005L15.205 11.666C15.598 11.85 15.598 12.15 15.205 12.334Z","fill":"#191919"}));
}

Youtube.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
